/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const CustomSativa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Custom Sativa"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M11.036 1.53a2 2 0 0 1 1.928 0l8 4.4A2 2 0 0 1 22 7.683v8.635a2 2 0 0 1-1.036 1.752l-8 4.4a2 2 0 0 1-1.928 0l-8-4.4A2 2 0 0 1 2 16.317V7.683A2 2 0 0 1 3.036 5.93z"
        className="Main"
      />
      <path
        fill="#fff"
        d="m9 14.943 1.311-1.14c.413.65 1.134 1.03 1.819 1.03.673 0 1.122-.344 1.122-.847 0-.49-.343-.833-1.17-1.128l-.708-.257c-1.346-.49-2.067-1.3-2.067-2.49 0-1.642 1.205-2.611 2.835-2.611 1.027 0 1.925.368 2.645 1.202l-1.134 1.214c-.401-.503-.92-.748-1.5-.748-.578 0-1.122.257-1.122.772 0 .527.414.76 1.3 1.091l.673.258c1.228.466 1.996 1.275 1.996 2.587-.012 1.557-1.205 2.624-2.94 2.624-1.336 0-2.458-.6-3.06-1.557"
        className="Details"
      />
    </g>
  </svg>
);

export const CustomSativaIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'custom-sativa-icon'}
      icon={CustomSativa}
      {...props}
      size={size}
    />
  );
};
